import { useTranslation } from 'react-i18next'

export const SettingsPage = () => {
  const { t } = useTranslation()
  return (
    <main>
      <h2>{t('shell.nav.settings')}</h2>
    </main>
  )
}

export const handle = { title: 'Settings' }
